module.exports = require("ngx-bootstrap/accordion");